import React, {Component, useEffect, useRef, useState} from 'react';
import axios from "axios";
import config from "../../configuration/config.json";
import {useTranslation} from "react-i18next";
function CenterInfo({data}) {

    const [cinderInfo, setCinderInfo] = useState({});

    const { t: trans, i18n } = useTranslation(['mobileCommon', 'new', 'fixAgreemnet', 'error']);
    let lang = i18n.language;

    useEffect(() => {
      console.log("CenterInfo IN COMPONENT: ", data);
        setCinderInfo(data);
    }, [data]);
    
    return(
        <div className="nice-container p-10 flex flex-row flex-wrap nice-gap-2rem">
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:service_provider')} :
        </span>
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {lang =='ar'
              ? (cinderInfo['ServiceProvidorAr'] ?? trans('new:HJ_company')) 
              :(cinderInfo['ServiceProvidorEn'] ?? trans('new:HJ_company'))}
        </span>
      </div>
      <div className="border-l text-gray-dark my-3 mx-3"></div>
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:tax_number')} :
        </span>
        <span className="text-24 text-bold text-super-gray my-2">
          {cinderInfo['TaxIDNum'] ?? ''}
        </span>
      </div>
      {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:address')} :
        </span>
        <span className="text-24 text-bold text-super-gray " title={trans('new:HJ_company')}>
          {lang == 'ar'
              ? (cinderInfo['BrnachAddressAr'] ?? trans('new:HJ_company'))
              :(cinderInfo['BranchAddressEn'] ?? trans('new:HJ_company'))   /*trans('new:Dammam_KingFahd_suburb_car_showroom') */}
        </span>
      </div>
      <div className="border-l text-gray-dark my-3 mx-5"></div>
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:commercial_record')} :
        </span>
        <span className="text-24 text-bold text-super-gray ">
          {cinderInfo['CRNumber'] ?? ''}
        </span>
      </div>
      {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:postal_code')} :
        </span>
        <span className="text-24 text-bold text-super-gray ">
          {(cinderInfo['PostalCodeE'] ?? cinderInfo['PostalCodeAr']) ?? ''}
        </span>
      </div>
      <div className="border-l text-gray-dark my-3 mx-5"></div>
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:mail_box')} :
        </span>
        <span className="text-24 text-bold text-super-gray ">
          {cinderInfo['POBox']}
        </span>
      </div>
      {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
      <div className="flex flex-row nice-gap-1rem">
        <span className="text-24 text-bold text-super-gray text-capitalize">
          {trans('new:contact_numbers')} :
        </span>
        <div className="flex flex-row nice-gap-2rem">
          <span className="text-24 text-bold text-info-light language-en border-line-b">
            <a
              className="text-24 text-bold text-info-light language-en "
              href={"tel: cinderInfo['CompanyTel']??'' "}
            >
              {cinderInfo['CompanyTel'] ?? ''}
            </a>
          </span>
          <span className="text-24 text-bold text-info-light language-en border-line-b">
            <a
              className="text-24 text-bold text-info-light language-en "
              href={"tel:cinderInfo['BranchTel'] ?? ''"}
            >
              {cinderInfo['BranchTel'] ?? ''}
            </a>
          </span>
        </div>
      </div>
    </div>
    );
}
export default CenterInfo;